// Odometer digits for a headline figure, v2 ("Tell-tale"), for the React app.
// Static-page equivalent: VeercalCalc.odometer in public/design/v2/calculators.js,
// which draws the same markup (.vc-odo, .vc-odo__d per digit, .vc-odo__s otherwise).
//
// <Odometer text="$48,200" />
//
// The figure is also in the page as plain text for screen readers (.vc-sr-only); the
// digits are hidden from them. The digits roll in (.vc-odo--roll, which respects
// prefers-reduced-motion) when they first appear and whenever the figure changes.

import React from 'react';

export default function Odometer({ text, className = '' }) {
  const t = String(text == null ? '' : text);
  return (
    <span className={`vc-odo-wrap${className ? ` ${className}` : ''}`}>
      <span className="vc-sr-only">{t}</span>
      {/* key: a new figure remounts the digits, so they roll in again */}
      <span key={t} className="vc-odo vc-odo--roll" aria-hidden="true">
        {Array.from(t).map((ch, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <span key={i} className={/\d/.test(ch) ? 'vc-odo__d' : 'vc-odo__s'}>{ch}</span>
        ))}
      </span>
    </span>
  );
}
